import { NudosButton } from 'components/NudosComponents';
import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { useHistory } from 'react-router-dom';
import { fgDefault } from 'styles/styles.constants';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import { SUMMARY_TYPE_ROUTE, SUMMARY_TYPE_TEXT } from '../../constants';
import './SummarySubmitSection.scss';

type TSummaryType = 'orders' | 'catalog' | 'quotes';
interface ISummarySubmitSectionProps {
  areErrors: boolean;
  errorTemplateURL?: string;
  handleReturnToUpload: () => void;
  typeOfSummary?: TSummaryType;
}

export const SummarySubmitSection = ({
  areErrors,
  errorTemplateURL,
  handleReturnToUpload,
  typeOfSummary = 'catalog'
}: ISummarySubmitSectionProps) => {
  const { push } = useHistory();

  const buttonContentWithIcon = (text: string, icon: TbordOneToneIcon, color: string) => {
    return (
      <div className="summary-submit-section-button-text">
        <span>{text}</span>
        <BordOneToneIcon variant={icon} customWidth="16px" stroke={color} />
      </div>
    );
  };

  const Button1Text = areErrors
    ? buttonContentWithIcon('Volver al cargue masivo', 'arrowRight', fgDefault)
    : `Ir a ${SUMMARY_TYPE_TEXT[typeOfSummary]}`;
  const Button2Text = areErrors
    ? buttonContentWithIcon('Descargar plantilla con errores', 'download', '#FFF')
    : 'Volver a cargue masivo';

  const handleLinkButton1 = () => (areErrors ? handleReturnToUpload() : push(SUMMARY_TYPE_ROUTE[typeOfSummary]));

  const handleLinkButton2 = () =>
    areErrors ? window.open(errorTemplateURL, '_blank') : push('/bulk-upload/type-of-charge');

  return (
    <section className="summary-submit-section">
      <NudosButton
        customWidth={areErrors ? '263px' : '122px'}
        customHeight="44px"
        buttonText={Button1Text}
        handleClick={handleLinkButton1}
        colorPalette="secondary"
      />
      <NudosButton
        customWidth={areErrors ? '263px' : '156px'}
        customHeight="44px"
        buttonText={Button2Text}
        handleClick={handleLinkButton2}
      />
    </section>
  );
};
